<template>
  <modal name="privacy" adaptive height="auto">
    <Wrapper>

      <h2>{{ $t('terms.privacy') }}</h2>

      <div v-html="$t('terms.privacyContent')" class="tos"></div>

      <div class="btn--bar">
        <button type="button" class="btn" @click="$emit('hideModal')"><i class="icon--cancel"></i> {{
          $t('general.close') }}
        </button>
      </div>
    </Wrapper>
  </modal>
</template>

<script>
import Wrapper from '@/components/Modal/Wrapper'

export default {
  name: 'Modal-Privacy',
  props: {},
  mounted () {
  },
  components: { Wrapper },
  data () {
    return {}
  },
  computed: {},
  methods: {}
}
</script>
